import $ from 'jquery';
import ConsentApi from "./ConsentApi";
import ConsentForm from "./ConsentForm";

window.consentApi = ConsentApi.getInstance();

window.consentForms = [];
$('.dsgvo-consent').each((i, e) => {
    window.consentForms.push(new ConsentForm(e, window.consentFormOptions, window.consentApi));
});

if (!window.consentApi.isConfirmed()) {
    if (!window.consentFormOptions.disablePopup) {
        window.consentApi.openPopup();
    } else {
        console.warn('DSGVO: Popup disabled, but no consent given.\n' +
            'Probably because there is an inline plugin on this page');
    }
}

window.consentApi.loadSnippets();

$('*[data-missing-identifiers]').on('click', ev => {
    ev.preventDefault();
    let identifiers = JSON.parse($(ev.currentTarget).attr('data-missing-identifiers'));
    for (let i = 0; i < identifiers.length; i++) {
        consentApi.enable(identifiers[i]);
    }
    window.location.reload();
});

consentApi.on('confirmed', (ev) => {
    $('*[data-missing-identifiers]').each((i, elem) => {
        let missingIdentifiers = JSON.parse($(elem).attr('data-missing-identifiers'));
        let newMissingIdentifiers = [];
        missingIdentifiers.forEach(identifier => {
            if (ev.identifiers.indexOf(identifier) === -1) {
                newMissingIdentifiers.push(identifier);
            }
        });

        if (newMissingIdentifiers.length === 0) {
            // force reload to show cooke walled elements.
            window.setTimeout(() => window.location.reload(), 0);
            return false;
        }
    });
});
